
// API
import * as apiContributions from '../api/private/contributions';

import errorsMixin from '../mixins/error-handler';

export default {
  name: 'SDeleteContribution',
  mixins: [errorsMixin],
  props: {
    contributionType: {
      type: String,
      required: true,
    },
    playgroundId: {
      type: Number,
      required: true,
    },
    showDeleteContribution: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showDialog: false,
      dialogOptions: {
        maxWidth: '600',
      },
      dialogTitle: 'Annuler ma contribution',
      dialogButtons: {
        closeText: 'Fermer',
        confirmText: 'Confirmer',
      },
      dialogLoading: false,
    };
  },
  computed: {
    getContributionType() {
      const match = (expression, cases) => cases[expression];
      return match(this.contributionType, {
        pics: 1,
        schedules: 2,
        street: 3,
        description: 4,
        location: 5,
        facilites: 6,
      });
    },
  },
  watch: {
    showDeleteContribution() {
      this.showDialog = this.showDeleteContribution;
      if (!this.showDeleteContribution) {
        this.errors$.reset('delete_contrib');
      }
    },
  },
  methods: {
    deleteContribution() {
      this.dialogLoading = true;
      this.errors$.reset('delete_contrib');
      apiContributions.deleteContribution({ type: this.getContributionType, playground: this.playgroundId }, this).then(() => {
        this.showDialog = false;
        this.$emit('update:show-delete-contribution', false);
        this.$emit('delete-contribution');
      }).catch((error) => {
        // Validation error
        if (error.response && error.response.status === 400) {
          if (this.errors$.hasErrors()) {
            return;
          }
          this.errors$.handleError(true, 'delete_contrib', 'form');
        }
      }).finally(() => {
        this.dialogLoading = false;
      });
    },
  },
};
